import {
  types,
  RecurrenceTypes,
  PeriodTypes,
  WeekdayTypes,
  MonthTypes,
  RecurrenceVariantTypes,
  IntradayRepeatTypes,
  IPublishScheduleFormState,
  IPublishScheduleActionType
} from '../types/publishSchedule'

export const initialState: IPublishScheduleFormState = {
  displayModal: false,
  displayDeleteModal: false,
  isRequestInProgress: false,
  fieldValues: {
    recurrence: RecurrenceTypes.none,
    everyNthPeriod: 1,
    recurrenceVariant: RecurrenceVariantTypes.dayByNumber,
    recurrenceDayNumber: 1,
    recurrenceWeekday: WeekdayTypes.Monday,
    recurrenceWeekdayCount: 1,
    recurrenceWeekdays: [],
    recurrenceMonth: MonthTypes.January,
    period: PeriodTypes.forever,
    occurrences: 1,
    intradayRepeat: IntradayRepeatTypes.none,
    intradayRepeatInterval: '5m',
    utc: false,
  },
  fieldErrors: {},
  schedules: [],
  schedulesLoading: false,
  schedulesLoaded: false,
}

export const publishSchedule = (
  state: IPublishScheduleFormState,
  action: IPublishScheduleActionType
): IPublishScheduleFormState => {
  switch (action.type) {
    case types.SET_FIELD_VALUE:
      return {
        ...state,
        fieldValues: {
          ...state.fieldValues,
          [action.fieldName]: action.value,
        },
      }
    case types.SET_FORM_ERRORS:
      return { ...state, fieldErrors: action.fieldErrors }
    case types.CLEAR_FORM_ERRORS:
      return { ...state, fieldErrors: {} }
    case types.SCHEDULE_REQUEST__START:
      return { ...state, isRequestInProgress: true }
    case types.SCHEDULE_REQUEST__FINISH:
      return { ...state, isRequestInProgress: false }
    case types.SCHEDULE_MODAL_OPEN:
      return {
        ...initialState,
        currentScheduleId: action.currentScheduleId,
        displayModal: true,
        fieldValues: {
          ...initialState.fieldValues,
          ...action.defaultFieldValues,
        },
        schedules: state.schedules,
        schedulesLoading: state.schedulesLoading,
        schedulesLoaded: state.schedulesLoaded,
      }
    case types.SCHEDULE_MODAL_CLOSE:
      return { ...state, displayModal: false, currentScheduleId: undefined }
    case types.SCHEDULE_DELETE_MODAL_OPEN:
      return { ...state, displayDeleteModal: true, currentScheduleId: action.currentScheduleId }
    case types.SCHEDULE_DELETE_MODAL_CLOSE:
      return { ...state, displayDeleteModal: false, currentScheduleId: undefined }
    case types.GET_SCHEDULES:
      return { ...state, schedulesLoading: true, schedulesLoaded: false }
    case types.GET_SCHEDULES__SUCCESS:
      return { ...state, schedules: action.schedules, schedulesLoading: false, schedulesLoaded: true }
    case types.GET_SCHEDULES__FAILURE:
      return { ...state, schedulesLoading: false, schedulesLoaded: true }
    default:
      return state
  }
}
